import { useQuery } from 'react-query';
import { apiClient, endpoints } from '../api/client';

export interface ServiceStatus {
  name: string;
  status: string;
  uptime: string;
  last_check: string;
  response_time: number;
}

export const useServiceStatus = () => {
  return useQuery<ServiceStatus[]>(
    'serviceStatus',
    async () => {
      const response = await apiClient.get(endpoints.systemStatus + '/services');
      return response.data;
    },
    {
      refetchInterval: 5000, // Refetch every 5 seconds
      staleTime: 0, // Always consider data stale
      cacheTime: 0, // Don't cache data
    }
  );
};
